import { Link } from 'react-router-dom'
import { pt } from '@/i18n/pt-PT'

export function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas p-8">
      <div className="text-center">
        <h1 className="text-[28px] font-semibold text-gray-900">404</h1>
        <p className="mt-2 text-[13px] text-gray-500">Página não encontrada.</p>
        <Link
          to="/admin"
          className="mt-4 inline-block text-[12px] font-medium text-brand-800 hover:underline"
        >
          {pt.auth.backToOps}
        </Link>
      </div>
    </main>
  )
}
